/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-use-before-define */
import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import axios from 'axios';
import useMessageDispatcher from '../../../../hooks/useMessageDispatcher';

// ===============================|| UI DIALOG - FORMS ||=============================== //

export default function DiscontinueHostel(props) {
    const [instituteLogo, setInstituteLogo] = useState('');
    const student = props?.student?.selectedStudent;
    console.log(student, 'student', props);

    const [date, setDate] = useState('');
    const showMessage = useMessageDispatcher();
    const downloadDocumentFunction = (fileName, type) => {
        axios
            .post(
                `/v1/utils/file/download`,
                { fileName },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then((result) => {
                if (type === 'logo') {
                    setInstituteLogo(result.data.data);
                }
            });
    };

    const getIntituteLogo = () => {
        axios
            .get(`/v1/institutes/get`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                    'Content-Type': 'application/json'
                }
            })
            .then((result) => {
                if (result.data.data.instituteLogo !== '' || result.data.data.header !== '' || result?.data?.data?.waterMark !== '') {
                    downloadDocumentFunction(result?.data?.data?.hallTicketHeader, 'logo');
                }
            });
    };

    useEffect(() => {
        getIntituteLogo();
    }, []);
    const discontinueAdmission = () => {
        console.log(props, 'props');

        axios
            .delete(`/v1/hostel/staff/vacate?staffId=${student?.staffMini?.staffId}&date=${date}`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                    'Content-Type': 'application/json'
                }
            })
            .then((result) => {
                // handlePrintInNewTab();
                showMessage({ message: result?.data?.Msg, color: 'success' });
                props.handleClose();
                props.fetchStaffDetails(props.fetchData);
            })
            .catch((error) => {
                if (!error.response) {
                    showMessage({ message: error.message, color: 'error' });
                } else {
                    showMessage({ message: error.response.data.Msg, color: 'error' });
                }
            });
    };
    const handleGetDiscontinue = (date) => {
        setDate(date);
    };

    return (
        <div>
            <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
                {props.open && (
                    <>
                        <DialogTitle id="form-dialog-title" width={500}>
                            Are you sure you want to Discontinue Hostel for {student?.staffMini?.staffName} ?
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sx={{ mt: 2 }}>
                                    <TextField
                                        type="date"
                                        id="joinDate"
                                        name="joinDate"
                                        required
                                        label="Discontinue Date"
                                        onChange={(e) => {
                                            handleGetDiscontinue(e.target.value);
                                        }}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'end', gap: 2 }}>
                                    <Button variant="contained" onClick={props.handleClose} color="error">
                                        Cancel
                                    </Button>
                                    <Button type="button" variant="contained" onClick={discontinueAdmission}>
                                        Discontinue
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions />
                    </>
                )}
            </Dialog>
        </div>
    );
}
